import { DataSourceExecutionEvent } from "@mcleod/components";
import { AutogenLayoutDriverQuickInfo } from "./autogen/AutogenLayoutDriverQuickInfo";

export class DriverQuickInfo extends AutogenLayoutDriverQuickInfo {
    sourceDriverAfterExecution(event: DataSourceExecutionEvent) {
        if (this.sourceDriverInfo.activeRow?.get("contact.mobile_phone")) {
            this.textboxContactmobilePhone.visible = true;
        } else {
            this.textboxContactphone.visible = true;
        }
    }

}
